export * from "./account-location-assigner.component";
